/**
 * BB-6-login-work-order Stage-6 completion: agent-facing translations
 * for the backend's normalized `SessionLoginFailureReason` values
 * (backend/app/telephony/session_login/contracts.py). Never surfaces
 * MariaDB/VICIdial topology, usernames, passwords, raw provider
 * responses, exception strings, or machine-auth detail -- every value
 * here is a short, fixed, reviewed sentence.
 */
export const CAMPAIGN_LOGIN_FAILURE_COPY = Object.freeze({
  credential_missing: "Your dialer credential isn't set up yet. Contact your administrator.",
  credential_resolution_failed: "Your dialer credential couldn't be verified. Contact your administrator.",
  provider_query_adapter_unavailable: "The dialer is temporarily unavailable. Try again in a moment.",
  machine_auth_failure: "The dialer is temporarily unavailable. Try again in a moment.",
  campaign_unauthorized: "You're no longer authorized for this campaign. Choose another.",
  admission_failed: "This campaign isn't accepting logins right now. Try another campaign or check back shortly.",
  native_dispatch_transport_failure: "The dialer is temporarily unavailable. Try again in a moment.",
  no_live_agent_row: "Login didn't complete. Try again.",
  wrong_campaign: "Login completed for a different campaign than requested. Try again.",
  status_not_paused: "Login didn't complete as expected. Try again.",
  pause_code_not_login: "Login didn't complete as expected. Try again.",
  stale_observation: "Couldn't confirm your login in time. Try again.",
  malformed_provider_response: "The dialer returned an unexpected response. Try again.",
  timeout: "Login timed out. Try again.",
});

export const DEFAULT_CAMPAIGN_LOGIN_FAILURE_MESSAGE = "Login didn't complete. Try again.";

export function campaignLoginFailureMessage(failureReason) {
  if (!failureReason) return DEFAULT_CAMPAIGN_LOGIN_FAILURE_MESSAGE;
  return CAMPAIGN_LOGIN_FAILURE_COPY[failureReason] || DEFAULT_CAMPAIGN_LOGIN_FAILURE_MESSAGE;
}
